import React, { useState, useEffect } from 'react'
//import CardComp from '../components/Card'
//import HorizontalScrollbar from '../components/HorizontalScrollBar'
import MasonryComp from '../components/Masonry'
import { Typography, Container, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Grid, Divider, TextField } from '@mui/material';
import { Helmet } from "react-helmet-async";

const Home = () => {
  const [open, setOpen] = useState(false);

  let [ articles, setArticles ] = useState([])

  const [subscribe, setSubscribe] = useState({name: '', email: ''})

  const backend = 'https://oureclecticsociety.org/core'
  const frontend = 'https://oureclecticsociety.com/'

  useEffect(() => {
    getArticle()
  }, [])

  let getArticle = async () => {
    try {
      let response = await fetch(`${backend}/articles/`)
      let data = await response.json()
      console.log(data)
      setArticles(data)
    } catch (error) {
      console.error(error)
    }
    
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if(subscribe){

      fetch(`${backend}/subscriber-create/`, {
        method : 'POST',
        headers : {"Content-type": "application/json"},
        body: JSON.stringify(subscribe)
      })

    }
    else{
      setOpen(true)
    }
    setOpen(false)
    window.location.reload()
     
  }


  return (
    <div>

      <Helmet>
        <title>OurEclecticSociety</title>
        <meta name="description"
          content="Welcome to OurEclecticSociety home of refreshing ideas and discussions
          on Africa's state of growth, culture, politics and thought"
        />
        <meta
          name="keywords"
          content="African, Nairobi, Growth, Economy, Culture, History, Politics, Society, Eclectic"
        />
        <meta property="og:title" content="Our Eclectic Society" />
        <meta property="og:description" content="Home of mindful thoughts and discussions" />
        <meta property="og:image" content="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBCx9vFl53HaCEXmR8GEAt17HSkg4haraDNw&s" />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="400" />
        <link rel="canonical" href="/" />
      </Helmet>

      <div className="top">
        <Container sx={{ textAlign: 'center'}}>
          <Typography className='welcome' variant='h4' color={'white'} sx={{ pt: 20}}> Welcome to</Typography>
          <Typography className='welcome' variant='h1' color={'white'}> Our Eclectic Society</Typography>
        </Container>
      </div>

      <Container sx={{ textAlign: 'center', py: 10, bgcolor: 'rgb(255, 255, 255)'}} maxWidth={false}>
      {/* <Container sx={{ textAlign: 'center', py: 10, bgcolor: '#051827'}} maxWidth={false}> */}
        <Typography fontWeight={800} variant='h5' sx={{mb: 1}} color={'grey'}>About Us</Typography>
        <Typography className='welcome' fontWeight={800} variant='h3' sx={{mb: 4}} color={'grey'}>ADULTING IN AN ECLECTIC SOCIETY</Typography>
        <Typography align='center' variant='h5' sx={{px:2}} color={'black'}>
          Humans all over the world are in pursuit of certain lifestyles.
          Some are quite successful at it, some are managing while
          others are barely surviving. There are different factors
          that influence our success in the journey of life including
          resources, beliefs, exposure, ambitions and governance among
          others. Our Eclectic Society instigates discussions around the
          elements that affect us as humans and most importantly as Africans
          for our own Growth and Development and for the Betterment of Future Generations to Come.
        </Typography>
        <Typography variant='h6'sx={{py: 2}} color={'black'}>No two People Experience The Same Event The Same Way.</Typography>

        <Button variant='contained' sx={{ backgroundColor: '#050505', borderRadius: 10, color: 'white'}} size='large' onClick={ ()=> setOpen(!open)}>Subscribe</Button> 
      </Container>

      <div className="middle">
        <Container sx={{ flexGrow: 1 }}>
          <Grid container spacing={4}>
            <Grid xs={6} md={6} sx={{pl: 2}}>
                {/* <Typography className='edo' variant= 'h3' sx={{ mt: 10}} color={'orange'}>Articles</Typography>
                <Typography className='edo' fontWeight={700} variant= 'h4' sx={{ my: 1}} color={'black'}>Array of topics we should discuss intently.</Typography> */}
                <Typography className='edo' variant= 'h3' sx={{ mt: 10}} color={'black'}>RECENT ARTICLES</Typography>
                <Divider sx={{borderBottomWidth: 2, backgroundColor: 'black'}}/>
                {articles.slice(0,3).map( (article) => (
                   <div key={article.id}>
                        <Typography className='edo' color={'orange'} fontWeight={700} variant='h4' sx={{ mt:2 }}>{article.title}</Typography>
                        <Typography color={'white'} variant='h6' sx={{mb: 2}}>{article.excerpt}</Typography>
                        <Divider sx={{borderBottomWidth: 2, backgroundColor: 'black'}}/>
                    </div>
                ) )} 
            </Grid>
            <Grid xs={6} md={6}sx={{pl: 8}}>
                <Typography color={'white'} variant="h4" sx={{ mt: 50}}>
                  No one likes to be called out on their bad behaviour,
                  yet, when we are called out, it's because the act is
                  detrimental to ourselves, or to the people around us.
                </Typography>
            </Grid>
          </Grid>
        </Container>        
      </div>

      <Dialog  open={open} onClose={ ()=> setOpen(false) }>
      <DialogTitle>SUBSCRIBE!</DialogTitle>
      <DialogContent>
          <DialogContentText>Subscribe so you can join our community of open discussions on matters that affect US</DialogContentText>
          <form>
            <TextField sx={{mb:2}} onChange={(e) => setSubscribe({...subscribe, name: e.target.value}) } label="Enter name..." variant="outlined" fullWidth/>
            <TextField onChange={(e) => setSubscribe({...subscribe, email: e.target.value}) } label="Enter email..." variant="outlined" fullWidth/>
          </form>
      </DialogContent>
      <DialogActions>
          <Button onClick={ ()=> setOpen(!open)} >Cancel </Button>
          <Button onClick={ handleSubmit } >Submit</Button>
      </DialogActions>
      </Dialog>
      <div>
        <Container sx={{ textAlign: 'center', mt: 20 }}>
          <Typography className='edo' variant='h2' fontWeight={700} fontFamily={'monospace'} sx={{ my: 10}}>Lets Talk About It</Typography>
          <MasonryComp articles={articles}/>
        </Container>
      </div>

    </div>
  )
}

export default Home

{/* <HorizontalScrollbar articles={articles}/>

<div>
  {articles.map( (article, index) => (
    <CardComp key={index} article={article} />
  ) )}
</div> */}
